const MATCHER_NUMERIC_INPUT_ATTRS = {
  inputMode: 'numeric',
  pattern: '[0-9]*'
} as const;

export { MATCHER_NUMERIC_INPUT_ATTRS };
